import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";

interface BarChartProps {
  data: any[];
  options?: {
    title?: string;
    xAxisTitle?: string;
    yAxisTitle?: string;
    xAxisKey?: string;
    yAxisKey?: string;
    color?: string;
  };
}

export function BarChart({ data, options = {} }: BarChartProps) {
  const {
    title,
    xAxisKey = "name",
    yAxisKey = "value",
    xAxisTitle = "X Axis",
    yAxisTitle = "Y Axis",
    color = "#2563eb"
  } = options;

  return (
    <div className="w-full">
      {title && (
        <h3 className="text-lg font-semibold text-center mb-4">{title}</h3>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <RechartsBarChart
          data={data}
          margin={{ top: 10, right: 30, left: 5, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={xAxisKey}
            label={{
              value: xAxisTitle,
              position: "bottom",
              offset: -10
            }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis
            label={{
              value: yAxisTitle,
              angle: -90,
              position: "insideLeft",
              offset: 0
            }}
          />
          <Tooltip />
          <Legend />
          <Bar
            name={yAxisTitle}
            dataKey={yAxisKey}
            fill={color}
            radius={[4, 4, 0, 0]}
          />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
}
